<!--
 * @Author: your name
 * @Date: 2021-03-02 19:05:38
 * @LastEditTime: 2024-07-31 16:23:26
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\materialList.vue
-->
<template>
  <div class="window-list">
    <div class="window-title flex-c-c">
      <span style="font-size:18px;">{{ $t('PE.ProgramList') }}</span>
      <!-- <img
          class="icon"
          src="@/assets/images/public/public_add.png"
          @click="() => addVdrWindow()"
          alt
          v-show="!(vdrInfor.type === 'look')"
      />-->
      <el-dropdown @command="addContentWindow" v-show="!(vdrInfor.type === 'look')">
        <img class="icon" src="@/assets/images/public/public_add.png" alt />
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="4">文本</el-dropdown-item>
          <el-dropdown-item command="6">数字时钟</el-dropdown-item>
          <el-dropdown-item command="7">模拟时钟</el-dropdown-item>
          <el-dropdown-item command="5">天气</el-dropdown-item>
          <el-dropdown-item command="13">正计时</el-dropdown-item>
          <el-dropdown-item command="12">倒计时</el-dropdown-item>
          <el-dropdown-item command="14">流媒体</el-dropdown-item>
          <el-dropdown-item command="17">RSS</el-dropdown-item>-->
          <el-dropdown-item :command="tool.type" v-for="tool in toolsList" :key="tool.type"
            v-show="tool.type !== '1' && tool.type !== '2'">{{ $t(tool.i18nTitle) }}</el-dropdown-item>
          <el-dropdown-item command="-1">{{ $t('PE.multimedia') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="window-child">
      <el-collapse v-model="vdrIndex" @change="handleChange" accordion v-if="!isSaveProgram">
        <el-collapse-item :name="index" v-for="(vdr, index) in vdrList" :key="vdr.idx">
          <template slot="title">
            <div class="window-title flex-b-c">
              <span
                style="padding-right: 30px; padding-left: 10px;">{{ $t('PE.Window') }}-{{ `${index + 1}` }}</span>
              <img class="icon" src="@/assets/images/public/public_delete.png" @click.stop="delVdrWindow(vdr.idx)"
                v-show="!(vdrInfor.type === 'look')" alt />
            </div>
          </template>
          <ul>
            <!-- <transition-group name="wicketlist"> -->
            <li v-for="(vdrChild, childIndex) in vdr.wicket" :key="vdrChild.field_item_nodeKey" :data-index="childIndex"
              data-drag="drag" draggable="true" @dragover="dragover" @drop="drop" @dragenter="dragenter"
              @dragstart="dragstart" @dragend="dragend" @dragleave="dragleave" @click="clickVdrChild(childIndex)"
              :id="vdrChild.field_item_nodeKey" style="margin-bottom: 4px; cursor: move;">
              <div class="vdr-child insert flex-c-c noclick"
                v-if="(insert.index == childIndex) && (insert.position == 'up')">
                {{ $t('PE.Insert') }}</div>
              <div class="vdr-child flex-b-c noclick" :class="{ 'vdr-child-select': vdr.activeIndex == childIndex }">
                <div class="vdr-child-image flex-c-c noclick">
                  <img class="vdr-child-icon" :src="vdrChild.ext_val_pimg" style="object-fit: contain;" alt />
                </div>
                <div class="media-details noclick">
                  <template v-if="vdrChild.type === '1' || vdrChild.type === '2'">
                    <div>{{ { "2": $t('cswcw1'), "1": $t('cswcw2') }[vdrChild.type] }}</div>
                    <div class="ellipsis-1">{{ vdrChild.ext_val_name }}</div>
                    <div>{{ sizeTransition(vdrChild.ext_val_size) }}</div>
                  </template>
                  <template v-else>
                    <div>{{ $t(vdrChild.field_i18n) }}</div>
                  </template>
                </div>
                <div class="vdr-child-del flex-c-c" v-show="!(vdrInfor.type === 'look')">
                  <span style="text-align: center;" @click.stop="delWicketChild(index, childIndex)"><i
                      class="el-icon-delete" style="font-size: 20px;"></i></span>
                </div>
              </div>
              <div class="vdr-child insert flex-c-c noclick"
                v-if="(insert.index == childIndex) && (insert.position == 'down')">
                {{ $t('PE.Insert') }}</div>
            </li>
            <!-- </transition-group> -->
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <media-list :dialogVisible="dialogVisible" @closeDialog="closeDialog"></media-list>
  </div>
</template>

<script>
// import * as TemplateData from "@/assets/scripts/programData.js"
import MediaList from "./MediaList"
import { addMaterialTools } from "../mixins";
import toolsList from './../scripts/toolsList.js';

export default {
  name: 'WindowList',
  mixins: [addMaterialTools],
  inject: {
    vdrInfor: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    // const toolsList = {
    //   "4": { title: "文本", type: "4", image: "program_text.png" },
    //   "6": { title: "数字时钟", type: "6", image: "program_numclock.png" },
    //   "7": { title: "模拟时钟", type: "7", image: "program_imitateclock.png" },
    //   "5": { title: "天气", type: "5", image: "program_weather.png" },
    //   "13": { title: "正计时", type: "13", image: "program_positivetime.png" },
    //   "12": { title: "倒计时", type: "12", image: "program_countdown.png" },
    //   "14": { title: "流媒体", type: "14", image: "program_media.png" },
    //   "17": { title: "RSS", type: "17", image: "program_Rss.png" },
    // }
    return {
      activeName: '0',
      moveNode: null,
      overNodeId: null,
      toolsList: toolsList(),
      dialogVisible: false,
      insert: {
        index: -1,
        position: "",
        setTime: null
      }

    }
  },
  mounted() {
    // this.winSize = { w: this.vdrInfor.w, h: this.vdrInfor.h };
    // 设备选择
    this.vdrInfor.deviceType === 'Pandora' && this.pandoraInit();
    this.vdrInfor.deviceType === 'Kommander' && this.kommanderInit();
    this.toolsList.forEach((tool) => {
      tool.image && (tool.image = require("@/assets/images/program/" + tool.image));
    });
    // for (const type in this.toolsList) {
    //   if (Object.hasOwnProperty.call(this.toolsList, type)) {
    //     this.toolsList[type].image = require("@/assets/images/program/" + this.toolsList[type].image);
    //   }
    // }
  },
  methods: {
    pandoraInit() {
      switch (this.vdrInfor.type) {
        case 'add': {
          this.vdrListLength === 0 && this.addVdrWindow();
        }
          break;
        default:
          break;
      }
    },
    kommanderInit() {
      // 初始化添加窗口
      switch (this.vdrInfor.type) {
        case 'add': {
          let gridList = JSON.parse(this.vdrInfor.gridList);
          gridList.forEach(grid => {
            const { x, y, w, h } = grid;
            this.addVdrWindow(x, y, w, h);
          });
        }
          break;
        default:
          break;
      }
    },
    sizeTransition(size) {
      size = parseInt(size);
      let M = (size / 1024 / 1024);
      if (M > 1024) {
        return `${(M / 1024).toFixed(2)}G`;
      }
      return `${M.toFixed(2)}M`;
    },
    // 窗口素材列表拖拽
    dragenter(event) {
      if (this.moveNode) {
        this.moveWindow(event);
      } else {
        clearTimeout(this.insert.setTime);
        this.insert.index = parseInt(event.target.getAttribute("data-index"));
      }
    },
    moveWindow() {
      if (!event.target.getAttribute("data-drag") || this.vdrInfor.type === 'look') { return; }
      if (this.overNodeId == event.target.id || this.moveNode.target.id == event.target.id) { return; }
      // let ids = event.target.id.split("-");
      // let vdrIndex = this.vdrList.findIndex((vdr) => vdr.idx == ids[1]);
      let id = event.target.id;
      let vdrIndex = this.vdrIndex;
      let wicketIndex = this.vdrList[vdrIndex].wicket.findIndex((wicket) => wicket.field_item_nodeKey == id);
      let activeId = this.vdrList[vdrIndex].wicket[this.vdrList[vdrIndex].activeIndex].field_item_nodeKey;
      let direction = "";//true - up ,false - down
      event.offsetY > 50 && (direction = 'up');
      event.offsetY < 10 && (direction = 'down');

      if (direction === 'up' && wicketIndex + 1 < this.vdrList[vdrIndex].wicket.length) {
        this.wicketChildSwap(vdrIndex, wicketIndex, wicketIndex + 1, activeId);
        this.$store.commit("VDR_LIST_EDIT", this.vdrList[vdrIndex]);
      }
      if (direction === 'down' && wicketIndex - 1 >= 0) {
        this.wicketChildSwap(vdrIndex, wicketIndex, wicketIndex - 1, activeId);
        this.$store.commit("VDR_LIST_EDIT", this.vdrList[vdrIndex]);
      }
    },
    wicketChildSwap(vdrIndex, index_1, index_2, activeId) {
      let temp = this.vdrList[vdrIndex].wicket[index_1];
      this.$set(this.vdrList[vdrIndex].wicket, index_1, this.vdrList[vdrIndex].wicket[index_2]);
      this.$set(this.vdrList[vdrIndex].wicket, index_2, temp);
      let activeIndex = this.vdrList[vdrIndex].wicket.findIndex((wicket) => wicket.field_item_nodeKey == activeId);
      this.$set(this.vdrList[vdrIndex], "activeIndex", activeIndex);
    },
    insertWindow(mediaTemplate, mediaType) {
      let position = -1;
      if (this.insert.position === 'up') {
        position = this.insert.index;
      } else {
        position = this.insert.index + 1;
      }
      // console.log(mediaTemplate, mediaType, this.vdrIndex, position);
      this.addWindowChild(mediaTemplate, mediaType, this.vdrIndex, position);
    },
    // 上下添加
    dragover(event) {
      if (event.offsetY < 80) {
        this.insert.position = 'up';
      } else {
        this.insert.position = 'down';
      }
      event.preventDefault();
    },
    // 待添加素材元素
    drop(event) {
      let vdrElement = document.getElementById(event.dataTransfer.getData("selectVdr"));
      if (!vdrElement) { return; }
      // console.log(vdrElement);
      // 获取工具或素材信息
      let mediaTemplate = JSON.parse(vdrElement.getAttribute("data-template"));
      let mediaType = vdrElement.getAttribute("data-type");
      this.insertWindow(mediaTemplate, mediaType);
      // 重置选中与触发信息
      this.insert.index = -1;
      this.moveNode = null;
    },
    // 获取当前移动素材元素
    dragstart(event) {
      this.moveNode = event;
    },
    dragend() {
      this.moveNode = null;
    },
    dragleave() {
      this.insert.setTime = setTimeout(() => {
        this.insert.index = -1;
      }, 100)
    },
    handleChange(val) {
      console.log(val);
    },
    clickVdrChild(index) {
      this.vdrList[this.vdrIndex].activeIndex = index;
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
    },
    delVdrWindow(idx) {
      // if (this.vdrListLength < 2) {
      //   this.$msg({ message: "编辑页面中窗口不能为空！", type: 'warning' });
      //   return;
      // }
      this.$store.commit('VDR_LIST_DEL', idx);
    },
    delWicketChild(vdrIndex, wicketIndex) {
      this.vdrList[vdrIndex].wicket.splice(wicketIndex, 1);
      if (this.vdrList[vdrIndex].activeIndex == 0) {
        this.vdrList[vdrIndex].activeIndex = 0;
      } else {
        this.vdrList[vdrIndex].activeIndex = this.vdrList[vdrIndex].activeIndex - 1;
      }
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[vdrIndex]);
    },
    // /**
    //  * @description: 
    //  * @param {*} x
    //  * @param {*} y
    //  * @param {*} w
    //  * @param {*} h
    //  * @return {*}
    //  */
    // addVdrWindow(x = 10, y = 10, w = 0, h = 0) {
    //   // console.log(x, y, w, h);
    //   let idMax = -1;
    //   let zIndexMax = -1;
    //   this.vdrList.forEach((vdr) => {
    //     vdr.idx > idMax && (idMax = vdr.idx);
    //     vdr.zIndex > zIndexMax && (zIndexMax = vdr.zIndex);
    //   });
    //   this.$store.commit("VDR_LIST_ADD", {
    //     type: "10",
    //     field: `wicket_${this.$uuid.v4()}`,
    //     field_cn: "窗口",
    //     idx: idMax + 1,
    //     zIndex: zIndexMax + 1,  // 组件当前层级
    //     activeIndex: 0,  // 当前激活子组件
    //     active: false,  //是否立即激活
    //     style: {
    //       fs: "0",
    //       ha: "0",
    //       va: "0"
    //     },
    //     x: x,
    //     y: y,
    //     w: w !== 0 ? w : parseInt(this.vdrInfor.w * 0.25),
    //     h: h !== 0 ? h : parseInt(this.vdrInfor.h * 0.25),
    //     wicket: []
    //   });
    //   this.$store.commit("VDR_INDEX", this.vdrListLength - 1);
    //   if (this.vdrListLength === 1) {
    //     setTimeout(() => {
    //       this.$store.commit("VDR_WIN_FULL", { x: 0, y: 0, w: this.vdrWindowSize.vdrw, h: this.vdrWindowSize.vdrh });
    //       this.setStyle('fs', 1);
    //     }, 100)
    //   }
    // },
    setStyle(key, val) {
      let wicket = this.vdrList[this.vdrIndex].wicket;
      if (wicket.length === 0) {
        return;
      }
      let activeIndex = this.vdrList[this.vdrIndex].activeIndex;
      // this.vdrList[this.vdrIndex].style[key] = val;
      wicket[activeIndex].style[key] = val;
      this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
    },
    // 添加工具与媒体窗口
    addContentWindow(type) {
      // 添加窗口
      if (type == -1) {
        this.dialogVisible = true;
      } else {
        this.addVdrWindow();
        let tool = this.toolsList.find(tool => tool.type == type);
        this.addWindowChild(tool, type);
      }
    },
    closeDialog(config, selectMedia) {
      if (config) {
        // 添加多媒体组件窗
        this.addVdrWindow();
        selectMedia.forEach((media) => {
          this.addWindowChild(media, media.type.toString());
        });
      }
      this.dialogVisible = false;
    },
    // addWindowChild(mediaTemplate, mediaType, index = this.vdrIndex) {
    //   let templateData = this.getTemplateData(mediaType);
    //   // start ; true 为媒体文件 false为工具组件
    //   if (mediaTemplate.id || mediaTemplate.group_id) {
    //     templateData.field_item_id = mediaTemplate.id;
    //     templateData.field_item_nodeKey = this.$uuid.v4();
    //     templateData.ext_val_name = mediaTemplate.ref_name;
    //     templateData.ext_val_pimg = mediaTemplate.ref_thumb_url;
    //     templateData.field_item_path = mediaTemplate.ref_url;
    //     templateData.ext_val_size = mediaTemplate.ref_size;
    //     templateData.field_item_playTime = mediaTemplate.ref_time;
    //   } else {
    //     templateData.field_item_id = this.$uuid.v4();
    //     templateData.field_item_nodeKey = this.$uuid.v4();
    //     templateData.ext_val_pimg = mediaTemplate.image;
    //   }
    //   templateData.w = this.vdrList[index].w;
    //   templateData.h = this.vdrList[index].h;
    //   // end
    //   this.vdrList[index].wicket.push(templateData);
    //   // 激活父级窗口
    //   this.vdrList[index].active = true;
    //   // 激活子级窗口
    //   this.vdrList[index].activeIndex = this.vdrList[index].wicket.length - 1;
    //   // 数据同步
    //   this.$store.commit("VDR_INDEX", index);
    //   this.$store.commit("VDR_LIST_EDIT", this.vdrList[index]);
    // },
    // // 获取窗口数据
    // getTemplateData(type) {
    //   switch (type) {
    //     case "5": return TemplateData.dataWeather();
    //     case "12": return TemplateData.dataCountdown();
    //     case "7": return TemplateData.dataIClock();
    //     case "2": return TemplateData.dataImage();
    //     case "14": return TemplateData.dataMedia();
    //     case "6": return TemplateData.dataNClock();
    //     case "17": return TemplateData.dataRss();
    //     case "4": return TemplateData.dataText();
    //     case "13": return TemplateData.dataTimewait();
    //     case "1": return TemplateData.dataVideo();
    //     // case "11": return TemplateData.dataCalendar();
    //     default: return "";
    //   }
    // }
  },
  computed: {
    vdrListLength() {
      return this.$store.getters.getVdrListLength;
    },
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrWindowSize() {
      return this.$store.state.program.vdrWindowSize;
    },
    // vdrChildIndex() {
    //   return this.$store.state.program.vdrChildIndex;
    // },
    vdrIndex: {
      get() {
        return this.$store.state.program.vdrIndex;
      },
      set(val) {
        typeof (val) === 'number' && this.$store.commit('VDR_INDEX', val);
      }
    },
    isSaveProgram() {
      return this.$store.state.program.isSaveProgram;
    }
  },
  components: {
    MediaList
  }
}
</script>
<style lang="scss" scoped>
.window-list {
  height: 100%;

  .window-title {
    height: 40px;
    // background: pink;
    border-bottom: 1px solid #d7ecf3;
    // font-family: 'Times New Roman';
    // font-weight: normal;
    // font-stretch: normal;
    // line-height: 3px;
    // letter-spacing: 3px;
    // color: #617883;
    font-size: 16px;
    position: relative;

    .el-dropdown {
      position: absolute;
      right: 6px;
    }

    .icon {
      width: 30px;
      height: 30px;
    }
  }

  .el-collapse {
    border-top: none;
  }

  .window-child {
    height: calc(100% - 41px);
    overflow: auto;

    .window-title {
      width: 100%;

      // padding-right: 30px;
      .icon {
        width: 30px;
        height: 30px;
        margin-right: 15px;
      }
    }

    .insert {
      font-size: 20px;
      opacity: 0.4;
    }

    .wicketlist-enter-active,
    .wicketlist-leave-active {
      transition: all 0.3s;
    }

    .wicketlist-enter,
    .wicketlist-leave-to

    /* .list-leave-active for below version 2.1.8 */
      {
      opacity: 0;
      transform: translateY(30px);
    }

    .vdr-child {
      height: 60px;
      border: 1px solid #d7ecf3;
      border-radius: 8px;
      border-left: 3px solid #d7ecf3;
      overflow: hidden;
      cursor: move;

      .vdr-child-image {
        padding-left: 4px;
        width: 96px;

        .vdr-child-icon {
          width: 96px;
          height: 54px;
          background: #F4F4F5;
        }
      }

      .media-details {
        width: calc(100% - 96px - 24px - 24px);
        font-size: 12px;
        color: #617883;

        div {
          line-height: 20px;
        }
      }

      .vdr-child-del {
        position: relative;
        width: 24px;
        height: 100%;
        // margin-right: 2px;
        background-image: linear-gradient(270deg,
            #ff907e 0%,
            #ff7878 45%,
            #ff5f72 100%),
          linear-gradient(#ffffff, #ffffff);
        background-blend-mode: normal, normal;
        color: #fff;
        border-radius: 0px 8px 8px 0px;
        cursor: pointer;
        // .icon {
        //   width: 20px;
        //   height: 20px;
        //   margin-right: 15px;
        //   position: absolute;
        //   top: 4px;
        // }
        pointer-events: auto;
      }
    }

    .vdr-child-select {
      background: #e5f9fd;
      border-left: 3px solid #4cccf0;
    }

    /deep/ .el-collapse-item__content {
      padding-bottom: 0px;
    }
  }
}

.noclick {
  pointer-events: none;
  /* 上层加上这句样式可以实现点击穿透 */
}
</style>